import useApplyFilter from "components/Filters/useApplyFilter";
import { PolicySuggestions, searchPolicySuggestionsDictionary } from "constants/policy";
import TableCellLabels from "ds/components/Table/Row/CellLabels";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Policy } from "types/generated";

const APPLY_FILTERS_SUGGESTIONS = {
  searchSuggestionsDictionary: searchPolicySuggestionsDictionary,
};

const PoliciesTableLabelsCell = ({ item: policy, ...cellProps }: TableSimpleCellProps<Policy>) => {
  const { applyFilter, applyLabelFilter } =
    useApplyFilter<PolicySuggestions>(APPLY_FILTERS_SUGGESTIONS);

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLabels
        tags={policy.labels}
        applyLabelFilter={applyLabelFilter(PolicySuggestions.Label)}
        applyFolderFilter={applyFilter(PolicySuggestions.Folder)}
      />
    </TableSimpleCell>
  );
};

export default PoliciesTableLabelsCell;
